import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";
import { useLoggedOutBrandNodes } from "./useLoggedOutBrandNodes";
import { useLoggedOutBrandNodesL1, useLoggedOutBrandNodesL2, useLoggedOutBrandNodesL3BySoyo, useLoggedOutBrandNodesL3BySwf } from "./useLoggedOutBrandNodesOption";
import { useLoggedOutRetailerNodes } from "./useLoggedOutRetailerNodes";
import { useLoggedOutRetailerNodesL1, useLoggedOutRetailerNodesL2 } from "./useLoggedOutRetailerNodesOption";
export var useLoggedOutIssuesDropdown = function useLoggedOutIssuesDropdown() {
  var _useLoggedOutContactU = useLoggedOutContactUsContextStore(["issueL1", "issueL2", "issueL3", "user", "currentStep"]),
    _useLoggedOutContactU2 = _slicedToArray(_useLoggedOutContactU, 2),
    _useLoggedOutContactU3 = _useLoggedOutContactU2[0],
    issueL1 = _useLoggedOutContactU3.issueL1,
    issueL2 = _useLoggedOutContactU3.issueL2,
    issueL3 = _useLoggedOutContactU3.issueL3,
    user = _useLoggedOutContactU3.user,
    setLoggedOutContactUsContextStore = _useLoggedOutContactU2[1];
  var brandNodes = useLoggedOutBrandNodes();
  var brandNodesL1 = useLoggedOutBrandNodesL1();
  var brandNodesL2 = useLoggedOutBrandNodesL2();
  var retailerNodes = useLoggedOutRetailerNodes();
  var retailerNodesL1 = useLoggedOutRetailerNodesL1();
  var retailerNodesL2 = useLoggedOutRetailerNodesL2();
  var brandNodesL3BySWF = useLoggedOutBrandNodesL3BySwf();
  var brandNodesL3BySOYO = useLoggedOutBrandNodesL3BySoyo();
  var isRetailer = user === "retailer";
  var issuesFromL1 = isRetailer ? retailerNodesL1 : brandNodesL1;
  var issuesFromL2 = isRetailer ? retailerNodesL2 : brandNodesL2;
  var showGoToOrderPageCopy = issueL1 === retailerNodes.L1.Items || issueL1 === retailerNodes.L1.Returns;
  var issuesFromL3 = function issuesFromL3() {
    switch (issueL2) {
      case brandNodes.L2.SWF:
        return brandNodesL3BySWF;
      case brandNodes.L2.SOYO:
        return brandNodesL3BySOYO;
      default:
        return [];
    }
  };
  var handleUserDropdown = function handleUserDropdown(option) {
    setLoggedOutContactUsContextStore({
      user: option.value,
      issueL1: "",
      issueL2: "",
      issueL3: ""
    });
  };
  var showDropdownL2 = function showDropdownL2() {
    if (isRetailer) {
      return issueL1 === retailerNodes.L1.GeneralShipping;
    }
    return issueL1 === brandNodes.L1.GeneralShipping;
  };
  var showDropdownL3 = function showDropdownL3() {
    if (isRetailer) {
      return false;
    }
    return !!issueL2 && issueL1 === brandNodes.L1.GeneralShipping && issueL2 !== brandNodes.L2.Other && issueL2 !== brandNodes.L2.SellingInternational;
  };
  var handleSelectL1 = function handleSelectL1(option) {
    setLoggedOutContactUsContextStore({
      issueL1: option.value,
      issueL2: "",
      issueL3: ""
    });
  };
  var handleSelectL2 = function handleSelectL2(option) {
    setLoggedOutContactUsContextStore({
      issueL2: option.value,
      issueL3: ""
    });
  };
  var handleSelectL3 = function handleSelectL3(option) {
    setLoggedOutContactUsContextStore({
      issueL3: option.value
    });
  };
  return {
    issueL1: issueL1,
    issueL2: issueL2,
    issueL3: issueL3,
    issuesFromL1: issuesFromL1,
    issuesFromL2: issuesFromL2,
    issuesFromL3: issuesFromL3,
    showDropdownL2: showDropdownL2,
    showDropdownL3: showDropdownL3,
    showGoToOrderPageCopy: showGoToOrderPageCopy,
    handleSelectL1: handleSelectL1,
    handleSelectL2: handleSelectL2,
    handleSelectL3: handleSelectL3,
    handleUserDropdown: handleUserDropdown
  };
};